import React, { useState } from "react";
import Button from "../Button";
import moment from "moment";
import TemplatePreview from "./TemplatePreview";

export default function TemplateSaveDialog({ 
  open, 
  onClose, 
  templates, 
  saving, 
  saveName, 
  onSaveNameChange, 
  overwriteId, 
  onOverwriteIdChange, 
  saveSearchFilter, 
  onSaveSearchFilterChange, 
  onSave,
  nameInputRef
}) {
  const [hoveredTemplate, setHoveredTemplate] = useState(null);

  if (!open) return null;

  const filteredOwnedTemplates = templates.filter(tpl => 
    tpl.owner && (!saveSearchFilter || tpl.name.toLowerCase().includes(saveSearchFilter.toLowerCase()))
  );

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      onSave();
    }
  };

  return (
    <div style={{ 
      position: "absolute", 
      background: "white", 
      border: "1px solid #ddd", 
      zIndex: 11, 
      maxHeight: 500, 
      minWidth: hoveredTemplate ? 1040 : 640,
      width: hoveredTemplate ? 1040 : 640,
      maxWidth: "90vw",
      right: 0,
      top: "100%",
      marginTop: 5,
      display: "flex",
      flexDirection: "column"
    }}>
      <div style={{ display: "flex", flex: 1, minHeight: 0 }}>
        <TemplatePreview template={hoveredTemplate} />
        <div style={{ flex: 1, display: "flex", flexDirection: "column", minWidth: 0 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: 10, borderBottom: "1px solid #eee" }}>
            <strong>{I18n && I18n.t ? I18n.t("templates.save_template") : "Save Template"}</strong>
            <a onClick={onClose} style={{ cursor: "pointer" }}>close</a>
          </div>
          {templates.filter((t) => t.owner).length > 5 && (
            <div style={{ padding: 10, flexShrink: 0 }}>
              <input
                className="form-control"
                placeholder="Search your templates..."
                value={saveSearchFilter}
                onChange={(e) => onSaveSearchFilterChange(e.target.value)}
              />
            </div>
          )}
          <div style={{ padding: 10 }}>
          <div style={{ marginBottom: 10 }}>
            <div className="input-group">
              <input
                ref={nameInputRef}
                className="form-control"
                placeholder={"Enter a new template name"}
                value={overwriteId ? "" : saveName}
                disabled={overwriteId != null}
                onChange={(e) => {
                  if (overwriteId == null) {
                    onSaveNameChange(e.target.value);
                  }
                }}
                onKeyPress={handleKeyPress}
              />
              <span className="input-group-btn">
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={onSave}
                  disabled={saving}
                  title={saving ? (I18n && I18n.t ? I18n.t("templates.saving") : "Saving...") : (I18n && I18n.t ? I18n.t("templates.save") : "Save")}
                >
                  <i className={saving ? "fa fa-spin fa-spinner" : "fa fa-check"} />
                  &nbsp;
                  Save
                </button>
              </span>
            </div>
          </div>
          <div style={{ color: "#777", marginBottom: 0 }}>
            {I18n && I18n.t ? I18n.t("templates.or_overwrite_existing") : "Or overwrite an existing template you own"}
            {overwriteId != null && (
              <span>
                &nbsp;&middot;&nbsp;
                <a style={{ cursor: "pointer" }} onClick={() => onOverwriteIdChange(null)}>
                  {I18n && I18n.t ? I18n.t("templates.clear_selection") : "Clear selection"}
                </a>
              </span>
            )}
          </div>
          {filteredOwnedTemplates.length === 0 && templates.filter((t) => t.owner).length > 0 && (
            <div style={{ color: "#777" }}>No templates match your search</div>
          )}
          {templates.filter((t) => t.owner).length === 0 && (
            <div style={{ color: "#777" }}>
              {I18n && I18n.t ? I18n.t("templates.no_owned_templates") : "You have not created any templates yet"}
            </div>
          )}
          {filteredOwnedTemplates.length > 0 && (
            <div style={{ overflowY: "auto", flex: 1 }}>
              <table className="table table-very-condensed table-striped table-hover" style={{ marginBottom: 0, width: "100%" }}>
                <thead>
                  <tr>
                    <th>{I18n && I18n.t ? I18n.t("templates.name") : "Name"}</th>
                    <th>{I18n && I18n.t ? I18n.t("templates.created_at") : "Created"}</th>
                    <th style={{ width: 50, textAlign: "right" }}>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredOwnedTemplates.map((tpl) => (
                      <tr
                        key={tpl.id}
                        onMouseEnter={() => setHoveredTemplate(tpl)}
                        onMouseLeave={() => setHoveredTemplate(null)}
                        style={{ 
                          cursor: "pointer",
                          backgroundColor: overwriteId === tpl.id ? "#fffacd" : "transparent"
                        }}
                        onClick={() => onOverwriteIdChange(overwriteId === tpl.id ? null : tpl.id)}
                      >
                      <td style={{ wordBreak: "break-word", overflowWrap: "anywhere" }}>
                        <strong>{tpl.name}</strong>
                      </td>
                      <td style={{ whiteSpace: "nowrap" }}>
                        {moment(tpl.created_at).format("YYYY-MM-DD HH:mm")}
                      </td>
                      <td style={{ textAlign: "right", whiteSpace: "nowrap" }}>
                        <Button
                          tiny
                          icon={overwriteId === tpl.id ? "fa-dot-circle-o" : "fa-circle-o"}
                          onClick={() => onOverwriteIdChange(overwriteId === tpl.id ? null : tpl.id)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: 10, borderTop: "1px solid #eee", flexShrink: 0 }}>
            <div style={{ color: "#999", fontSize: 12 }}>
              {I18n && I18n.t ? I18n.t("templates.custom_attributes_not_saved") : "Custom sample attributes cannot be saved in templates"}
            </div>
            <Button 
              title={saving ? (I18n && I18n.t ? I18n.t("templates.saving") : "Saving...") : (I18n && I18n.t ? I18n.t("templates.save") : "Save")} 
              icon={saving ? "fa-spin fa-spinner" : "fa-check"} 
              onClick={onSave} 
            />
          </div>
          </div>
        </div>
      </div>
    </div>
  );
}
